import React from 'react';
import classnames from 'classnames';
import { SuperSpeedIconComponent } from 'swag-client-common/components/partials/super-speed-icon/super-speed-icon';
import { pluralize } from 'swag-common/utils/strings';
import { SUPER_SPEED_PROD_TIME_TOOLTIP } from 'swag-client-common/components/partials/header-icons/header-icons-constants';
import { ProductionTimeTooltip } from 'swag-client-common/components/partials/production-time-tooltip';
import { Placement } from 'swag-client-common/constants';
import { variables } from 'swag-client-common/styles/variables-js';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './production-time-block.scss';
export const ProductionTimeBlockComponent = ({
  shouldDisabled,
  productionTime,
  onProductionTimeClick,
  isHidden,
  isProductionTimeClickable,
  isGreyProductionTime,
  shouldShowInfoTooltip,
  isLimitedEdition,
  rowClassName = '',
  labelClassName = '',
  valueClassName = '',
  wrapperClassName = '',
  shouldShowProductionTimeLabel = true,
  isEmbellishmentMethodSelected
}) => {
  if (!productionTime || isHidden) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  const {
    name,
    time
  } = productionTime;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.productionTimeBlockWrapper, wrapperClassName)
  }, /*#__PURE__*/React.createElement("div", {
    "data-footer": "ProductionTime",
    className: classnames(classes.rowMobile, {
      [classes.disabled]: shouldDisabled,
      [classes.clickable]: isProductionTimeClickable
    }, rowClassName),
    onClick: () => {
      if (isProductionTimeClickable && !shouldDisabled) {
        onProductionTimeClick();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.secondaryText, labelClassName)
  }, "Production Time:"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.emphasizedText, valueClassName),
    "data-production-name": name,
    tabIndex: isProductionTimeClickable && !shouldDisabled ? 0 : -1,
    "aria-label": "Open production time popup",
    onKeyDown: e => handleOnEnterPressed(e, onProductionTimeClick)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flexRow
  }, name === SUPER_SPEED_PROD_TIME_TOOLTIP && /*#__PURE__*/React.createElement(SuperSpeedIconComponent, {
    iconClassName: classes.fixedSSIcon,
    className: classes.flexRow,
    title: SUPER_SPEED_PROD_TIME_TOOLTIP
  }), shouldShowProductionTimeLabel && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.hiddenOnTablet, classes.marginRight, classes.nowrap)
  }, name, " -")), !isEmbellishmentMethodSelected && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.marginRight, classes.capitalizeOnTablet)
  }, "from"), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.pinkUnderlined, {
      [classes.disabled]: shouldDisabled,
      [classes.orangeText]: isLimitedEdition,
      [classes.greyText]: isGreyProductionTime
    }, valueClassName)
  }, time), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.marginRight, {
      [classes.greyText]: isGreyProductionTime
    })
  }, "Business"), /*#__PURE__*/React.createElement("div", {
    className: classes.flexRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.greyText]: isGreyProductionTime
    })
  }, pluralize(time, 'Day', 's', true)), !shouldDisabled && isProductionTimeClickable && /*#__PURE__*/React.createElement("div", {
    className: classes.pencil
  }), shouldShowInfoTooltip && /*#__PURE__*/React.createElement(ProductionTimeTooltip, {
    infoWrapperClassName: classes.productionTimeInfoWrapper,
    infoItemColor: isLimitedEdition ? variables.colorOrange : variables.colorPrimary,
    placement: Placement.TOP
  })))));
};